import { render, staticRenderFns } from "./Admin-Factor-Listing.vue?vue&type=template&id=77fd0cb6&scoped=true&"
import script from "./Admin-Factor-Listing.vue?vue&type=script&lang=js&"
export * from "./Admin-Factor-Listing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77fd0cb6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/Temp Code/HRM/hrm_front-end/hrm-frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VDatePicker } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarItems } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VContainer,VDataTable,VDatePicker,VFlex,VIcon,VLayout,VMenu,VSpacer,VTextField,VToolbar,VToolbarItems,VToolbarTitle,VTooltip})
